module.exports = __webpack_public_path__ + "media/soundtrack.7fa66337.mp3";